import { Map as IMap } from 'immutable';


export const SET_SENDER_OPTIN = '@@storefront/SET_SENDER_OPTIN';




const initialState = IMap();

export const senderReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SENDER_OPTIN:
            return state.set('optIn', action.value);
        default:
    }
    return state;
};

export const setSenderOptin = value => ({
    type: SET_SENDER_OPTIN,
    value
});
